import type {
  ICountry,
  IDistrict,
  IProvince,
  ISubDistrict,
} from 'features/Address/model'
import type { Dispatch } from 'react'
import type { BranchForForm } from 'types'

import { isEmpty } from 'lodash'
import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { useFormContext } from 'react-hook-form'

import { getAddressField } from 'helpers/common'
import * as utils from 'helpers/getAddress'
import { branchFormState } from 'recoils/atoms/branchFormAtom'

type UseBranchAddressEdit = (
  countries: ICountry[],
  setProvinces: Dispatch<IProvince[]>,
  setDistricts: Dispatch<IDistrict[]>,
  setSubDistricts: Dispatch<ISubDistrict[]>,
  setIsProvincesLoading: Dispatch<boolean>,
  setIsDistrictsLoading: Dispatch<boolean>,
  setIsSubDistrictsLoading: Dispatch<boolean>,
) => void

export const useBranchAddressEdit: UseBranchAddressEdit = (
  countries,
  setProvinces,
  setDistricts,
  setSubDistricts,
  setIsProvincesLoading,
  setIsDistrictsLoading,
  setIsSubDistrictsLoading,
) => {
  const { setValue } = useFormContext<BranchForForm>()
  const { branchFormEditAddress: address } = useRecoilValue(branchFormState)

  const setAddress = async () => {
    setIsProvincesLoading(true)
    setIsDistrictsLoading(true)
    setIsSubDistrictsLoading(true)

    const country = getAddressField(countries, 'country', address)
    setValue('country', country)

    const { provinces } = await utils.getProvinces(country.id)
    const province = getAddressField(provinces, 'province', address)
    setValue('province', province)
    setProvinces(provinces)
    setIsProvincesLoading(false)

    const { districts } = await utils.getDistricts(province.id)
    const district = getAddressField(districts, 'district', address)
    setValue('district', district)
    setDistricts(districts)
    setIsDistrictsLoading(false)

    const { subDistricts } = await utils.getSubDistricts(district.id)
    const subDistrict = getAddressField(subDistricts, 'subDistrict', address)
    setValue('subDistrict', subDistrict)
    setSubDistricts(subDistricts)
    setIsSubDistrictsLoading(false)
  }

  useEffect(() => {
    if (isEmpty(address)) {
      return
    }

    setAddress()
  }, [address, countries])
}
